import { render, staticRenderFns } from "./CollectivesListWidget.vue?vue&type=template&id=23b8d216"
import script from "./CollectivesListWidget.vue?vue&type=script&lang=js"
export * from "./CollectivesListWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports